import React from "react";

const DentalOrOpticalCheckListContent = {
  checklistText: <p>Before you start, please have the following ready:</p>,
  checklist: ["Fully itemised invoices, receipts, or bills for your claim",
  "This should include the patient’s name with the dates, amounts and details of the items or treatment"],
  checklistSLA:
    "Once you've submitted your documents, please allow up to 10 working days for us to review them.",
  infoBoxIconClass: "icon-help-outline"
};

const SMEDentalOrOptical = {
  HOL: {
    ...DentalOrOpticalCheckListContent,
    checklistText: <p>Before you start, please have the following ready:</p>
  },

  Any: DentalOrOpticalCheckListContent
};

export default SMEDentalOrOptical;
